import type { BlockVariableConfig, ValuesForExportOptions } from '../types'

const entityAttributeProperties = [
  'context_parameter',
  'context_value',
  'context_parameter_original_value',
  'entity_slug'
] as const

export type EntityAttributeBlockProperties =
  (typeof entityAttributeProperties)[number]

export const getVariablesFromEntityAttributeBlock =
  (): BlockVariableConfig => ({
    isAccessedByIndex: false,
    properties: [...entityAttributeProperties]
  })

const validateState = (
  state: ValuesForExportOptions['state']
): state is Record<string, unknown> =>
  Boolean(state && typeof state === 'object')

export const getValuesFromEntityAttributeBlock = ({
  state,
  blockMetadata
}: ValuesForExportOptions): Partial<
  Record<EntityAttributeBlockProperties, string>
> => {
  if (!validateState(state) || !blockMetadata) {
    return {}
  }

  const { entityId, newValue, oldValue, slug } = state

  return {
    ...(typeof entityId === 'string' && { context_parameter: entityId }),
    ...(typeof newValue === 'string' && { context_value: newValue }),
    ...(typeof oldValue === 'string' && {
      context_parameter_original_value: oldValue
    }),
    ...(typeof slug === 'string' && { entity_slug: slug })
  }
}
